import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'main-walking': {
			// ?safe&mock-data&utm_source=FB&country=US&area=main-walking&exp=web_main_walking_adapted_first_screen_by_utm~1
			landing: {
				experiment: () =>
					import(
						/* webpackChunkName: "landing" */ '@/modules/Landing/instances/experiments/web_main_walking_adapted_first_screen_by_utm'
					),
			},
		},
	},
]

export default config
